import React, { useState } from 'react';

import { get } from 'lodash-es';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const StyleTextField = styled(TextField)(({ theme }) => ({
  fontSize: 14,
  '& .MuiInputBase-root': {
    background: theme?.palette?.booking?.backgroundField
  }
}));

const StyleIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.light
}));

const PasswordInput = ({
  field = {}, // { name, value, onChange, onBlur }
  form: { touched, errors } = {},
  size = 'small',
  variant = 'outlined',
  required,
  maxLength = null,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <StyleTextField
      autoComplete='off'
      size={size}
      type={showPassword ? 'text' : 'password'}
      id={`outlined-adornment-password-${field.name}`}
      variant={variant}
      error={Boolean(get(touched, field?.name) && get(errors, field?.name))}
      helperText={get(touched, field?.name) && get(errors, field?.name)}
      inputProps={{ maxLength }}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <StyleIconButton
              aria-label='toggle password visibility'
              onClick={handleClickShowPassword}
              edge='end'
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </StyleIconButton>
          </InputAdornment>
        )
      }}
      {...field}
      {...rest}
      required={required}
      FormHelperTextProps={{ ['data-test-id']: field?.name }}
    />
  );
};

export default PasswordInput;
